import React, { useRef } from 'react';
import Navbar from '../components/Navbar';
import Header from '../components/HomeHeader';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import Register from './Register';
import axios from 'axios';
import { getClickIds, getFunnel, getAffiliateParams } from '../utils/tracking';

const Home = () => {

  // affiliate (?r=) and ttclid/fbclid cookies are written globally by
  // LanguageProvider, so this page only needs to fire the pixel.
  React.useEffect(() => {
    // Send pixel data to API. Click ids are included in the body as a fallback
    // to the cookie (and so this works the same way the landing page does).
    const pixelData = {
      event: 'home_view',
      funnel: getFunnel(),
      ...getClickIds(),
      ...getAffiliateParams(),
    }
    axios.post('https://api.viralgpt.com/pixel', pixelData, {
      withCredentials: true
    })
      .catch(err => console.error('Error sending pixel data:', err));

  }, []);
  return (
    <div style={{ overflowX: 'hidden' }}>
      {/* One way forward: the hero's Start Growing button goes to /pricing,
          which is where the offer, the checkout and the free boost widget all
          live now. The plan cards and the boost widget used to sit here and
          gave the page three competing entry points, two of which skipped
          /pricing entirely. */}
      <Navbar />
      <Header />
      <Testimonials />
	  <FAQ />

      <Footer />

    </div>
	
  );
};

export default Home;
